//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// ============================================================
// IntlFooter 组件逻辑
// ============================================================
import { intlMixin } from '@/i18n/intl-i18n';
export default {
  name: 'IntlFooter',
  mixins: [intlMixin]
};